import { HStack, Skeleton, useColorModeValue } from '@chakra-ui/react';
import { t } from 'i18next';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';

const rowStyle = { width: 'max-content', display: 'flex', flexDirection: 'row' };

const filterButtonClass = (filled) =>
  `inline-flex items-center justify-center rounded-full min-w-[37px] min-h-[28px] py-[6px] px-[12px] text-[13px] font-medium leading-[16px] cursor-pointer whitespace-nowrap border ${
    filled
      ? 'bg-primary-light dark:bg-primary-dark text-pure-white border-transparent'
      : 'border-label-light dark:border-label-dark text-text-main-lv4'
  }`;

const EventsGroupList = ({
  events,
  isLoading = false,
  selectedEventCategoryName = 'all',
  onSelectedEventCategory,
  addEntireOption = true
}) => {
  const startColor = useColorModeValue('separator.light.1', 'separator.dark.1');
  const endColor = useColorModeValue('separator.light.2', 'separator.dark.2');
  const primaryStartColor = useColorModeValue('secondary.light', 'secondary.dark');
  const primaryEndColor = useColorModeValue('theirty.light', 'theirty.dark');

  if (isLoading) {
    return (
      <HStack paddingY={'8px'} paddingLeft={'24px'}>
        <Skeleton
          height="33px"
          width="47px"
          borderRadius={'32px'}
          startColor={primaryStartColor}
          endColor={primaryEndColor}
        />
        <Skeleton
          height="33px"
          width="47px"
          borderRadius={'32px'}
          startColor={startColor}
          endColor={endColor}
        />
        <Skeleton
          height="33px"
          width="47px"
          borderRadius={'32px'}
          startColor={startColor}
          endColor={endColor}
        />
      </HStack>
    );
  }

  const safeEvents = events ?? [];
  const groupedEvents = safeEvents.reduce((acc, event) => {
    const categoryName = event.categoryName;
    if (!acc[categoryName]) {
      acc[categoryName] = { categoryName, count: 0 };
    }
    acc[categoryName].count += 1;
    return acc;
  }, {});

  const groupedEventArray = Object.values(groupedEvents);

  return (
    <div className="w-full">
      <ScrollMenu wrapperClassName="padding-left-scroll-container" scrollContainerClassName="py-[1px]">
        <div style={rowStyle}>
          {addEntireOption && (
            <button
              type="button"
              className={filterButtonClass(selectedEventCategoryName === 'all')}
              onClick={() => onSelectedEventCategory('all')}
            >
              {t('entire')}
            </button>
          )}
        </div>

        {groupedEventArray.map(({ categoryName, count }) => (
          <div key={categoryName} style={rowStyle}>
            <button
              type="button"
              className={filterButtonClass(selectedEventCategoryName === categoryName)}
              onClick={() => onSelectedEventCategory(categoryName)}
            >
              {`${categoryName} (${count})`}
            </button>
          </div>
        ))}
      </ScrollMenu>
    </div>
  );
};

export default EventsGroupList;
